import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import ExerciseLineItemCalendar from "../../../dashboard/calendar/components/ExerciseLineItemCalendar";
import { anySetCompleted } from "../../../../utils/actuals";
import {
  calculatePrefixForExercise,
  buildSupersets,
} from "../../../../utils/prefix-calculator";
import SvgIcon from "../../../../parts/SvgIcon";

const hasNumber = (string) => {
  return /\d/.test(string);
};

const CalendarExerciseRow = (
  { exercise, exerciseOrder, isWeekView, exercises, activeUserToRequest },
  { locals }
) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(!expanded);

  let { activeUser, withWeight, units, fromMetric } = locals;
  units = activeUser.units || units;
  const intensityMeasure =
    get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
      ? "RPE"
      : "RiR";
  const isRiR = intensityMeasure === "RiR";
  const isAssistant = exercise.type === "assistant";
  const isPrimary = exercise.type === "primary";
  const activeExerciseIndex = exercises.findIndex(
    (ex) => ex._id == exercise._id
  );
  const isLast = exerciseOrder === exercises.length - 1;
  const nextExercise = !isLast && exercises[activeExerciseIndex + 1];
  const isSuperset = exercise.nextSuperset === nextExercise._id;
  // Already in KG, so set.load / defaultRepMax will calculate correctly since both are stored in KG
  // gets primary repmax of the exercise if exercise type is primary else
  // if secondary, use secondary rm, else if assistant just use active user's squat (RM doesn't really matter for assistant)
  // if all else fails, default to 0
  const defaultRepMax = get(
    exercise,
    isPrimary ? `repMaximums.${exercise.primary}` : "secondaryRepMaximum",
    get(activeUser, "repMaximums.squat", 0)
  );
  const hideVelocitySettings = activeUser.hideVelocitySettings !== false;

  const supersets = buildSupersets(exercises);

  let prefix = "";
  if (activeExerciseIndex >= 0) {
    prefix = calculatePrefixForExercise(exercise._id, supersets);
  }

  let prefixHasNumber = hasNumber(prefix);
  const isAnySetCompleted = anySetCompleted(exercise);
  return (
    <li
      className={`exercise ${isSuperset ? "is-superset" : ""} ${
        prefixHasNumber && prefix.slice(1) != "1" ? "not-first-superset" : ""
      } ${prefixHasNumber && exercise.nextSuperset ? "not-last-superset" : ""}`}
    >
      {exercise.sets.map((set, idx) => (
        <ExerciseLineItemCalendar
          key={`${exercise._id}set${idx}`}
          isWeekView={isWeekView}
          withWeight={withWeight}
          units={units}
          fromMetric={fromMetric}
          isAssistant={isAssistant}
          defaultRepMax={defaultRepMax}
          set={set}
          idx={idx}
          exercise={exercise}
          exercises={exercises}
          prefix={prefix}
          isAnySetCompleted={isAnySetCompleted}
          expanded={expanded}
          toggleExpanded={toggleExpanded}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          hideVelocitySettings={hideVelocitySettings}
        />
      ))}
      {exercise.notes && (
        <div className="exnotes">
          <SvgIcon src="/img/new-icons/message-icon.svg" />
          <p className="p2">{exercise.notes}</p>
        </div>
      )}
    </li>
  );
};

CalendarExerciseRow.contextTypes = { locals: PropTypes.object };

export default CalendarExerciseRow;
